var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83323 2C8.08636 2 8.29559 2.18801 8.32875 2.43205L8.33333 2.4999L8.33413 7.33333H13.1695C13.4457 7.33333 13.6695 7.55719 13.6695 7.83333C13.6695 8.08646 13.4814 8.29566 13.2374 8.32877L13.1695 8.33333H8.33413L8.33549 13.1661C8.33555 13.4422 8.11174 13.6662 7.8356 13.6662C7.58247 13.6662 7.37323 13.4782 7.34007 13.2341L7.33549 13.1663L7.33413 8.33333H2.50146C2.22532 8.33333 2.00146 8.10948 2.00146 7.83333C2.00146 7.5802 2.18957 7.37101 2.43362 7.3379L2.50146 7.33333H7.33413L7.33333 2.5001C7.33327 2.22396 7.55708 2 7.83323 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddWhite);
export default __webpack_public_path__ + "static/media/icon-add-white.5b5437cc1078f7a1fe928a38e8b3a650.svg";
export { ForwardRef as ReactComponent };